/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import { PlayIcon, UnitIcon, UnitRightIcon } from "@/icons";
import { useTranslation } from 'react-i18next';
import { openWebSide } from "@/utility/utils";
import "./bookGames.scss";
interface BookGamesProps {
  bookId: number;
  bookGames: any[];
}
const BookGames: React.FC<BookGamesProps> = ({ bookGames }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'book_detail' });
  const [activeUnit, setActiveUnit] = useState<any | null>(null);

  useEffect(() => {
    if (bookGames.length > 0) {
      const firstUnitWithVideos = bookGames.find(
        (unit) => unit.items?.length > 0
      );
      if (firstUnitWithVideos) {
        setActiveUnit(firstUnitWithVideos);
      }
    }
  }, [bookGames]);

  const openGame = (url: any) => {
    openWebSide(url.link);
  };

  if (!activeUnit) return null;

  return (
    <div className="book-game-wrapper">
      <div className="book-game-container">
        <div className="book-game-sidebar">
          <div className="sidebar-header">
            <UnitIcon className="unit-icon" />
            <span>{t("units")}</span>
          </div>

          <div className="unit-list">
            {bookGames.map((unit) => {
              if (!unit.items?.length) return null;

              return (
                <div
                  key={unit.id}
                  className={`unit-item ${activeUnit.id === unit.id ? "active" : ""}`}
                  onClick={() => setActiveUnit(unit)}
                >
                  <div className="unit-info">
                    <div className="unit-icon-wrapper">
                      <UnitIcon className="unit-icon" />
                    </div>
                    <div className="unit-text">
                      <span className="unit-title">{unit.title}</span>
                      <div className="unit-meta">
                        <span className="unit-count">
                          {unit.items.length} game
                        </span>
                      </div>
                    </div>
                  </div>
                  <UnitRightIcon className="arrow-icon" />
                </div>
              );
            })}
          </div>
        </div>

        <div className="book-game-content">
          <div className="content-main">
            <div className="content-header">
              <div className="header-title">
                <h2>{activeUnit.title}</h2>
              </div>
            </div>

            <div className="game-grid">
              {activeUnit.items.map((game: any) => (
                <div
                  key={game.id}
                  className={`game-card`}
                  onClick={() => openGame(game)}
                >
                  <div className="game-info">
                    <button className="play-btn">
                      <PlayIcon className={undefined}></PlayIcon>
                    </button>
                    <span className="game-title">
                      {game.title.toLowerCase() !== "games"
                        ? game.title
                        : t("playGame")}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookGames;
